import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';

const ConfirmTerminatePaymentProtectionInsurance = ({ confirmAction }: ModalProps) => {
  const { t } = useTranslation('Modal', { keyPrefix: 'ConfirmTerminatePaymentProtectionInsurance' });

  return (
    <Modal title={t('title')}>
      <p>{t('info')}</p>
      <ModalActions>
        <Button variant="destructive" onClick={() => confirmAction?.()}>
          {t('button')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default ConfirmTerminatePaymentProtectionInsurance;
